var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5 0.18457)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.54 12.446C23.54 11.6306 23.4668 10.8465 23.3309 10.0938H12.5V14.5422H18.6891C18.4225 15.9797 17.6123 17.1976 16.3943 18.0131V20.8985H20.1109C22.2855 18.8965 23.54 15.9483 23.54 12.446Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 23.6841C15.605 23.6841 18.2081 22.6544 20.1109 20.898L16.3943 18.0125C15.3645 18.7025 14.0472 19.1103 12.5 19.1103C9.50474 19.1103 6.96951 17.0873 6.06519 14.3691H2.22314V17.3487C4.11542 21.1071 8.00451 23.6841 12.5 23.6841Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06523 14.3701C5.83523 13.6801 5.70455 12.943 5.70455 12.1851C5.70455 11.4271 5.83523 10.6901 6.06523 10.0001V7.02051H2.22318C1.44432 8.57301 1 10.3294 1 12.1851C1 14.0407 1.44432 15.7971 2.22318 17.3496L6.06523 14.3701Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5.25843C14.1884 5.25843 15.7043 5.83866 16.8961 6.97821L20.1945 3.6798C18.2029 1.82412 15.5997 0.68457 12.5 0.68457C8.00451 0.68457 4.11542 3.26162 2.22314 7.02002L6.06519 9.99957C6.96951 7.28139 9.50474 5.25843 12.5 5.25843Z",
    fill: "#EA4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.f68b45365fe3e38593a9496c88b08b2e.svg";
export { ForwardRef as ReactComponent };